<template>
  <el-col>
    <el-table v-if="units != null" :height="windowHeight - 268" @row-click="editUnit" :data="units">
      <el-table-column
        label="Name"
        :fixed="$mq === 'xs' ? false : 'left'"
        sortable
        prop="name"
        min-width="150"
      ></el-table-column>
      <el-table-column
        label="AD Group"
        :fixed="$mq === 'xs' ? false : 'left'"
        sortable
        prop="ad_group"
        min-width="100"
      ></el-table-column>
    </el-table>
    <div class="clearfix">
      <el-row type="flex" style="margin: 8px; justify-content: flex-end;" class="bottom">
        <el-button
          @click="editUnit({name: '', ad_group: ''})"
          type="primary"
          size="small"
          icon="el-icon-plus"
        ></el-button>
      </el-row>
    </div>
    <el-dialog title="Manage Unit" :visible.sync="dialogManageUnitVisible" :fullscreen="$mq === 'xs'">
      <el-form :label-position="labelPosition" :model="delUnit">
        <el-form-item label="Name" :label-width="formLabelWidth">
          <el-input v-model="delUnit.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="Group" :label-width="formLabelWidth">
          <el-input v-model="delUnit.ad_group" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          style="float: left;"
          v-if="delUnit.o_id"
          @click="showDeleteDialog(delUnit)"
        >Delete</el-button>
        <el-button @click="dialogManageUnitVisible = false">Cancel</el-button>
        <el-button type="primary" @click="saveUnit(delUnit)">Save</el-button>
      </span>
    </el-dialog>
    <el-dialog title="Confirm Unit Deletion" :visible.sync="deleteDialogVisible" width="45%" center :fullscreen="$mq === 'xs'">
      <p>Would you like to cascade deletion to subordinate units of {{delUnit ? delUnit.name : ''}}?</p>
      <span slot="footer" class="dialog-footer">
        <div style="display: flex; justify-content: space-between;">
          <el-button @click="deleteDialogVisible = false">No</el-button>
          <el-button-group>
            <el-button type="danger" @click="deleteUnit(delUnit, true)">Cascade</el-button>
            <el-button type="danger" @click="deleteUnit(delUnit, false)">Unit Only</el-button>
          </el-button-group>
        </div>
      </span>
    </el-dialog>
  </el-col>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
    components: {},
    data() {
        return {
            negCount: -1,
            backupData: [],
            dialogManageUnitVisible: false,
            deleteDialogVisible: false,
            formLabelWidth: "140px",
            delUnit: {
                name: "",
                ad_group: ""
            },
            window: {
                width: 0,
                height: 0
            }
        };
    },
    computed: {
        ...mapFields(["user", "units"]),
        levelFilters() {
            var t = [];
            if (this.levels == null) return t;
            this.levels.map((level) => {
                t.push({text: level.name, value: level.o_id});
            });
            return t;
        },
        labelPosition() {
            return this.$mq == "xs" ? "top" : "left";
        }
    },
    mounted() {
        if (this.units == null) this.$store.dispatch("pullUnits");
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
        showDeleteDialog(unit) {
            this.delUnit = unit;
            this.deleteDialogVisible = true;
        },
        saveUnit(row) {
            var route = "";
            if (row.o_id > -1) {
                route = "/api/v1/units/" + row.o_id;
                this.axios
                    .put(
                        route,
                        JSON.stringify({
                            name: row.name,
                            ad_group: row.ad_group
                        }),
                        {
                            headers: {"Content-Type": "application/json"},
                            credentials: "same-origin"
                        }
                    )
                    .then((response) => {
                        this.$message({
                            showClose: true,
                            message: "Unit saved successfuly.",
                            type: "success"
                        });
                        var temp = this.units.find((objv) => objv.o_id == row.o_id);
                        var index = this.units.indexOf(temp);
                        this.units.splice(index, 1, response.data);
                        this.dialogManageUnitVisible = false;
                    })
                    .catch((err) => {
                        var errorMessage = "";
                        err.response.data.errors.forEach((element) => {
                            errorMessage += element + "<br/>";
                        });
                        this.$message({
                            showClose: true,
                            message: errorMessage,
                            type: "error"
                        });
                    });
            } else {
                route = "/api/v1/units";
                this.axios
                    .post(
                        route,
                        JSON.stringify({
                            name: row.name,
                            ad_group: row.ad_group
                        }),
                        {
                            headers: {"Content-Type": "application/json"},
                            credentials: "same-origin"
                        }
                    )
                    .then((response) => {
                        this.units.push(response.data);
                        this.$message({
                            showClose: true,
                            message: "Unit created successfuly",
                            type: "success"
                        });
                        this.dialogManageUnitVisible = false;
                    })
                    .catch((err) => {
                        this.$message({
                            showClose: true,
                            message: err.response.data.errors.title,
                            type: "error"
                        });
                    });
            }
        },
        editUnit(val) {
            this.delUnit = JSON.parse(JSON.stringify(val));
            this.dialogManageUnitVisible = true;
        },
        cancelEditUnit() {
            this.dialogManageUnitVisible = false;
        },
        deleteUnit(unit, cascade) {
            this.axios({
                url: "/api/v1/units/" + unit.o_id + "?cascade=" + cascade,
                method: "delete",
                headers: {"Content-Type": "application/json"}
            })
                .then(() => {
                    this.$store.dispatch("pullPositions");
                    this.$message({
                        showClose: true,
                        message: "Unit deleted successfuly",
                        type: "success"
                    });
                    var temp = this.units.find((objv) => objv.o_id == unit.o_id);
                    var index = this.units.indexOf(temp);
                    this.units.splice(index, 1);
                    this.deleteDialogVisible = false;
                    this.dialogManageUnitVisible = false;
                })
                .catch((err) => {
                    this.$message({
                        showClose: true,
                        message: err.response.data.errors.title,
                        type: "error"
                    });
                });
        }
    }
};
</script>
